/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from "react";
import TopicsPerson from "../topics-page/topics-person/topics-person";
import TopicsMovie from "../topics-page/topics-movie/topics-movie";
import TopicsOrganization from "../topics-page/topics-organization/topics-organization";
import styles from "./styles.m.css";

const TopicsPage = () => {
  const [activeTab, setActiveTab] = useState("persons");
  return (
    <div className="container">
      <div className={`${styles["topicspage-section"]}`}>
        <div className={styles["tabs"]}>
          <h1
            className={activeTab === "persons" ? styles["active"] : styles["tab-button"]}
            onClick={() => setActiveTab("persons")}
          >
            Persons
          </h1>
          <h1
            className={activeTab === "movies" ? styles["active"] : styles["tab-button"]}
            onClick={() => setActiveTab("movies")}
          >
            Movies
          </h1>
          <h1
            className={activeTab === "organizations" ? styles["active"] : styles["tab-button"]}
            onClick={() => setActiveTab("organizations")}
          >
            Organizations
          </h1>
        </div>
        <div className={styles["tab-content"]}>
          {activeTab === "persons" && <TopicsPerson />}
          {activeTab === "movies" && <TopicsMovie />}
          {activeTab === "organizations" && <TopicsOrganization />}
        </div>
      </div>
    </div>
  );
};

export { TopicsPage };
